export default function InfoField({
  label,
  value,
}: {
  label: string
  value: string | number
}) {
  return (
    <div className="space-y-1 flex flex-col text-base">
      <p className="font-semibold">{label}</p>
      <p className="break-words">{value}</p>
    </div>
  )
}
